/**
 * Created by Fernando Torres on 17/11/2017.
 */

export default {
  model: function () {
    return {
      username: '',
      password: '',
      rememberMe: false
    }
  },
  rules: {
    username: {
      required: true,
      message: 'El usuario es requerido.',
      trigger: 'blur'
    },
    password: {
      required: true,
      message: 'La contraseña es requerida.',
      trigger: 'blur'
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/login/login.model.js